import { DevType, useWinResizeQuery } from 'hooks/useWinResizeQuery';
import { useEffect } from 'react';
import { create } from 'zustand';

type ZstdWinResize = {
  devType: DevType;
  isMobile: boolean;
  isTablet: boolean;
  isMini: boolean;
  setDevType: (devType: DevType) => void;
  setIsMobile: (isMobile: boolean) => void;
  setIsTablet: (isTablet: boolean) => void;
  setIsMini: (isMini: boolean) => void;
  winWidth: number;
  winHeight: number;
  setWinWidth: (devWidth: number) => void;
  setWinHeight: (devHeight: number) => void;
};
const useZstdWinResize = create<ZstdWinResize>((set) => ({
  devType: 'desktop',
  isMobile: false,
  isTablet: false,
  isMini: false,
  setDevType: (devType: DevType) => set({ devType }),
  setIsMobile: (isMobile: boolean) => set({ isMobile }),
  setIsTablet: (isTablet: boolean) => set({ isTablet }),
  setIsMini: (isMini: boolean) => set({ isMini }),
  winWidth: 0,
  winHeight: 0,
  setWinWidth: (winWidth: number) => set({ winWidth }),
  setWinHeight: (winHeight: number) => set({ winHeight }),
}));

/*
  사용하는 곳에서 호출. 
*/
export type WinResizeInfo = {
  devType: DevType;
  isMobile: boolean;
  isTablet: boolean;
  isMini: boolean;
  winWidth: number;
  winHeight: number;
};
export const useWinResize = (): WinResizeInfo => {
  const { devType, isMobile, isTablet, isMini, winWidth, winHeight } = useZstdWinResize();
  return { devType, isMobile, isTablet, isMini, winWidth, winHeight };
};

type WithStoreProps<T> = T & WinResizeInfo;

// 4. withStore HOC 구현
export const withWinResiz = <P extends object>(WrappedComponent: React.ComponentType<WithStoreProps<P>>) => {
  const WithStoreComponent = (props: P) => {
    const store = useWinResize();
    return <WrappedComponent {...props} {...store} />;
  };

  WithStoreComponent.displayName = `withWinResiz(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithStoreComponent;
};

/*
App.tsx 에서만 호출하도록( 전역적으로 한번만 ) 
*/
export const useSetWinResize = () => {
  const { setDevType, setIsMobile, setIsTablet, setIsMini, setWinWidth, setWinHeight } = useZstdWinResize();
  const { isMobile, isTablet, devType, isMini, winWidth, winHeight } = useWinResizeQuery();
  useEffect(() => {
    setDevType(devType);
  }, [setDevType, devType]);

  useEffect(() => {
    setIsMobile(isMobile);
  }, [setIsMobile, isMobile]);

  useEffect(() => {
    setIsTablet(isTablet);
  }, [setIsTablet, isTablet]);

  useEffect(() => {
    setIsMini(isMini);
  }, [setIsMini, isMini]);

  useEffect(() => {
    setWinWidth(winWidth);
  }, [setWinWidth, winWidth]);

  useEffect(() => {
    setWinHeight(winHeight);
  }, [setWinHeight, winHeight]);
};
